import { render } from "./BaseSingleCheckbox.vue?vue&type=template&id=3e644864&ts=true"
import script from "./BaseSingleCheckbox.vue?vue&type=script&lang=ts"
export * from "./BaseSingleCheckbox.vue?vue&type=script&lang=ts"

import "./BaseSingleCheckbox.vue?vue&type=style&index=0&id=3e644864&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__